import React, { useState, useEffect } from 'react';
import moment from 'moment';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { RecoilRoot } from "recoil";
import axios from 'axios';
import "antd/dist/antd.css";
import Header from './components/Header';
import { useRecoilState } from 'recoil';
import { user_data, redir, w_labels, langs, chosen_lang, surveys, _options, _questions, _surveystatus, _questionsinprogress, _online, _lastlogin, _logindiff, _offlineready, _orglogo, _hasorglogo, _otpcountry } from './RecoilState';
import _ from 'lodash';
import { Spin, message } from 'antd';
import "core-js/actual/array/group-by"
import FirebaseOTP from './firebase/BDMWOTP';



// axios.defaults.baseURL = 'https://mwtest.ecodevsolutions.com/api/v1/';

// client middleware url

// RDRS
// axios.defaults.baseURL = 'https://mpoweru.rdrsbangladesh.org/api/v1/';
// axios.defaults.baseURL = 'https://rdrs-mw.mpower-u.org/api/v1/';
// axios.defaults.baseURL = 'https://rdrs-onprem-mw.mpower-u.org/api/v1/';

// RDRS Working Proxy
// axios.defaults.baseURL = 'https://rdrsproxy.mpower-u.org/index.php/api/v1/';

// BRAC
// axios.defaults.baseURL = 'https://brac-mw.mpower-u.org/api/v1/';

// CRISIL
// axios.defaults.baseURL = 'https://crisil-mw.mpower-u.org/api/v1/';

// EcoDev Pilot
// axios.defaults.baseURL = 'https://ecodev-pilot-mw.mpower-u.org/api/v1/';

// UNDP
// axios.defaults.baseURL = 'https://undp-mw.mpower-u.org/api/v1/';

// BURO
// axios.defaults.baseURL = 'https://buro-mw.mpower-u.org/api/v1/';

// APIIP
// axios.defaults.baseURL = 'https://apiip-mw.mpower-u.org/api/v1/';

// NEIF
// axios.defaults.baseURL = 'https://neif-mw.mpower-u.org/api/v1/';

// IMI
// axios.defaults.baseURL = 'https://imi-mw.mpower-u.org/api/v1/';

// SERP
axios.defaults.baseURL = 'https://serp-mw.mpower-u.org/api/v1/';

axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('respondent_mpu_token');

const Main = () => {
  const [redirect, setRedirect] = useState("splash");
  const [gr, setGr] = useRecoilState(redir)
  const [userdata, setUserdata] = useRecoilState(user_data);
  // const [userrole, setUserrole] = useRecoilState(user_role);
  // const [userdetails, setUserdetails] = useRecoilState(user_details);
  const [labels, setLabels] = useRecoilState(w_labels);
  const [languages, setLanguages] = useRecoilState(langs);
  const [asurveys, setAsurveys] = useRecoilState(surveys);
  const [c_lang, setCLang] = useRecoilState(chosen_lang);
  const [questions, setQuestions] = useRecoilState(_questions);
  const [options, setOptions] = useRecoilState(_options);
  const [surveystatus, setSurveystatus] = useRecoilState(_surveystatus);
  const [progress, setProgress] = useRecoilState(_questionsinprogress);
  const [isonline, setIsonline] = useRecoilState(_online);
  const [lastlogin, setLastlogin] = useRecoilState(_lastlogin);
  const [logindiff, setLogindiff] = useRecoilState(_logindiff);
  const [offlineready, setOfflineReady] = useRecoilState(_offlineready);
  const [orglogo, setOrglogo] = useRecoilState(_orglogo);
  const [hasorglogo, setHasorglogo] = useRecoilState(_hasorglogo);
  const [otpcountry, setOtpcountry] = useRecoilState(_otpcountry);

  useEffect(() => {
    window.addEventListener("offline", () => {
      setIsonline(false);
    });
    window.addEventListener("online", () => {
      setIsonline(true);
    });
  })

  useEffect(() => {
    logincheck();
    fetchbasics();
    surveydetails();
    setprogress();
    fetchorglogo();
    // setGr("err");
  }, []);

  const fetchorglogo = () => {
    axios.get('/organization-logo')
      .then((response) => {
        // console.log(response);
        if (response.data.data === null || response.data.data.logo === null || response.data.data.logo_small === null) {
          setHasorglogo(false);
          setOtpcountry("none")
        } else {
          setHasorglogo(true);
          setOrglogo(response.data.data);
          setOtpcountry(response.data.data.location)
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  const setprogress = (value) => {
    // console.log(surveystatus);
    if (progress.length !== 0) {
      // console.log("questions remaining")
      // console.log(value)
      // console.log(progress.length)
    } else if (progress.length === 0 && surveystatus !== "green") {
      // console.log("empty")
      // for( let i = 0; i < questions.length; i++ ) {}
      // console.log(value)
      setProgress(value)
    } else {
      // console.log(surveystatus);
    }
  }

  const surveydetails = () => {
    delete axios.defaults.headers.common["Authorization"];

    // axios.get('wp/v2/questions?per_page=50')
    //fetch all questions
    // axios.get('wp/v2/questions?per_page=99')

    //fetch 5 questions for demo purposes
    axios.get('/get-modified-question', { baseURL: 'https://mpu-langcache-v2.mpower-u.org/index.php' })
      .then((response) => {
        // console.log(response);
        // setTempquestion(response.data);
        // fetchques(response);
        // processques(response.data);
        setprogress(response.data);
        setQuestions(response.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios.get('/get-modified-option', { baseURL: 'https://mpu-langcache-v2.mpower-u.org/index.php' })
      .then((response) => {
        // processoptn(response.data);
        setOptions(response.data);
        console.log(response.data);
        // optn(response.data);
      })
      .catch((err) => {
        console.log(err);
      });

    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('respondent_mpu_token');
  }

  //fetch all questions
  // const fetchques = async (response) => {
  //   // console.log(response.headers['x-wp-totalpages']);
  //   delete axios.defaults.headers.common["Authorization"];

  //   const allData = [];

  //   let page = 1;

  //   while (true) {

  //     const response = await axios.get(`wp/v2/questions?per_page=50&page=${page}`, { baseURL: 'https://mpu.ecodevsolutions.com/wp-json/' });

  //     allData.push(...response.data);

  //     const totalPages = response.headers['x-wp-totalpages'];

  //     if (page >= totalPages) {
  //       break;
  //     }

  //     page++;
  //   }

  //   // console.log(allData)

  //   processques(allData);


  //   axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('respondent_mpu_token');
  // }


  const processques = (value) => {
    // console.log(value);

    let question = {}; let qid, qcat = Number; let qslug = String; let tempques = [];
    for (let i = 0; i < value.length; i++) {
      // console.log(value[i]);
      question = value[i].acf;
      qcat = value[i].survey_category[0];
      // console.log(qcat);
      qid = value[i].id;
      qslug = value[i].slug;

      tempques.push({ question, qcat, qid, qslug });
    }
    setprogress(tempques);
    setQuestions(tempques);
  }

  const logincheck = () => {
    const hide = message.loading({
      content: 'Loading',
      style: {
        marginTop: '5vh',
      },
    });

    console.log("Token Validity Checking");
    let auth = localStorage.getItem('respondent_mpu_token');
    // console.log(auth);

    // console.log("login check");
    // Login Logic
    // console.log(isonline);
    // console.log(redirect);

    // if (isonline === true) {
    if (auth != null) {
      console.log("Token Found");
      axios.get('respondent/profile')
        .then((response) => {
          // console.log(response)
          if (response.data.status === "success") {
            // console.log("JWT token validated ");
            setTimeout(hide, 0);
            message.success({
              content: 'Successfully Logged-In',
              style: {
                marginTop: '5vh',
              },
              duration: 1,
            });
          } else {
            message.error({
              content: 'Auto Log-In Failed. Please LogIn Again. Your Data is Safe',
              style: {
                marginTop: '5vh',
              },
              duration: 1
            });
            setGr("lang");
            setRedirect("lang");
            localStorage.removeItem('respondent_mpu_token')
          }
        }).catch((error) => {
          console.error("Failed to fetch user data " + error);
          message.error({
            content: 'Auto Log-In Failed.',
            style: {
              marginTop: '5vh',
            },
            duration: 1
          });
          setRedirect("lang");
          setGr("lang");
          localStorage.removeItem('respondent_mpu_token');
        });

    } else {
      console.log("No Token");
      setTimeout(hide, 100);
      // message.error('Auto Log-In Failed.', 1);
      // localStorage.removeItem('respondent_mpu_token');
    }
    // }
    // else if (isonline === false) {
    //   // setRedirect("content");
    // }

  }

  const fetchbasics = async () => {
    delete axios.defaults.headers.common["Authorization"];

    axios.get('/get-page/264', { baseURL: 'https://mpu-langcache-v2.mpower-u.org/index.php' })
      .then((response) => {

        // Check Cached General Labels
        if (labels.length === 0) {
          setLabels(response.data.acf.labels);
          // console.log("labels not found ... downloading");
          // console.log(response.data.acf.labels);
        }
        else if (_.isEqual(labels, response.data.acf.labels)) {
          // console.log("labels up to date");
        }
        else {
          setLabels(response.data.acf.labels);
          // console.log("labels outdated ... updating");
          // console.log(response.data.acf.labels);
        }

        // Check Cached Languages
        if (languages.length === 0) {
          setLanguages(response.data.acf.languages);
          // console.log("languages not found ... downloading");
          // console.log(response.data.acf.languages);
        }
        else if (_.isEqual(languages, response.data.acf.languages)) {
          // console.log("languages up to date");
        }
        else {
          setLanguages(response.data.acf.languages);
          // console.log("languages outdated ... updating");
          // console.log(response.data.acf.languages);
        }

        // Check Cached Surveys
        if (asurveys.length === 0) {
          setAsurveys(response.data.acf.surveys);
          // console.log("surveys not found ... downloading");
          // console.log(response.data.acf.languages);
        }
        else if (_.isEqual(asurveys, response.data.acf.surveys)) {
          // console.log("surveys up to date");
        }
        else {
          setAsurveys(response.data.acf.surveys);
          // console.log("surveys outdated ... updating");
          // console.log(response.data.acf.languages);
        }

        setTimeout(() => {
          // console.log("waiting to redirect ...");
          setRedirect("next");
        }, 500);

      })
      .catch((error) => {
        console.log(error)
      })

    axios.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('respondent_mpu_token');
  }

  return (
    <>
      {
        (redirect === "splash") ?
          <>
            {/* Splash Screen - Checks Login state and JWT Token */}
            <div className="flex flex-col h-screen">
              <div className="m-auto">
                <Spin />
                <div className="h-16">
                  <img src={require('./assets/mpoweru_logo.png')} width={125} alt="mpower-u logo" />
                  <h3 className="splash-text brand-color">innovate.impact</h3>
                </div>
              </div>

              {/* load logo from state */}
              <div className="m-auto">
                <>
                  {
                    hasorglogo ?
                      <img src={orglogo.logo} width={150} alt="client logo" />
                      : null
                  }
                </>
                {/* <img src={require('./assets/crisil_logo.png')} width={150} alt="client logo" /> */}
              </div>
            </div>
          </>
          :
          <>
            <Header />
            <App />
          </>
      }

    </>
  )
}


ReactDOM.render(
  <RecoilRoot>
    <Main />
    {/* <>
      {/* <FirebaseOTP /> */}
    {/* {isonline ? <Main /> : <h1>Device is Offline</h1>} */}
    {/* </>  */}
  </RecoilRoot>,
  document.getElementById('root')
);


// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register();
